import React from 'react';
import { Car, Trash2, BarChart2, Clock, Droplet, Gauge } from 'lucide-react';
import { formatNumber, formatCurrency } from '../../../../../utils/formatting';
import Button from '../../../../../components/ui/Button';

/**
 * Компонент боковой панели для сохраненных автомобилей
 */
const SavedVehiclesSidebar = ({ 
  savedVehicles, 
  deleteSavedVehicle, 
  loadSavedVehicle 
}) => {
  // Если нет сохраненных автомобилей
  if (!savedVehicles || savedVehicles.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
          <Car className="w-5 h-5 mr-2 text-blue-500" />
          Мои автомобили
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Здесь будут отображаться сохраненные автомобили с их параметрами расхода топлива и стоимости поездок.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white flex items-center">
          <Car className="w-5 h-5 mr-2 text-blue-500" />
          Мои автомобили
        </h3>
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {savedVehicles.length} {savedVehicles.length === 1 ? 'авто' : savedVehicles.length < 5 ? 'авто' : 'авто'}
        </span>
      </div>

      <div className="space-y-4">
        {savedVehicles.map((vehicle) => (
          <div 
            key={vehicle.id} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-4 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors group"
          >
            <div className="flex justify-between items-start mb-2">
              <h4 className="text-sm font-medium text-gray-900 dark:text-white flex items-center">
                <Car className="w-4 h-4 mr-1.5 text-blue-500" />
                {vehicle.name}
              </h4>
              <div className="flex items-center space-x-2">
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<BarChart2 className="w-4 h-4" />}
                  onClick={() => loadSavedVehicle(vehicle.id)}
                  title="Загрузить параметры"
                />
                <Button
                  size="sm"
                  variant="ghost"
                  icon={<Trash2 className="w-4 h-4 text-red-500" />}
                  onClick={() => deleteSavedVehicle(vehicle.id)}
                  title="Удалить"
                />
              </div>
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <div className="grid grid-cols-2 gap-x-4 gap-y-1">
                <div className="flex items-center justify-between">
                  <span className="text-xs flex items-center">
                    <Droplet className="w-3 h-3 mr-1 text-blue-500" />
                    Расход:
                  </span>
                  <span className="font-medium">
                    {formatNumber(vehicle.results.fuelConsumptionWithEco, 1)} л/100км
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs flex items-center">
                    <Clock className="w-3 h-3 mr-1 text-blue-500" />
                    Топливо:
                  </span>
                  <span>
                    {vehicle.fuelType}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs flex items-center">
                    <Gauge className="w-3 h-3 mr-1 text-blue-500" />
                    100 км:
                  </span>
                  <span className="font-medium text-indigo-600 dark:text-indigo-400">
                    {formatCurrency(vehicle.results.costPer100km, 0)}
                  </span>
                </div>
                {vehicle.formData.vehicleInfo.make && (
                  <div className="flex items-center justify-between">
                    <span className="text-xs">Модель:</span>
                    <span>
                      {vehicle.formData.vehicleInfo.make} {vehicle.formData.vehicleInfo.model}
                    </span>
                  </div>
                )}
              </div>
              
              <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-600 text-xs flex items-center text-gray-500 dark:text-gray-400">
                <Clock className="w-3 h-3 mr-1" />
                Сохранено: {new Date(vehicle.date).toLocaleDateString()}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedVehiclesSidebar;